<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import { datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
        },
        projetos: [],
        relatorio: [],
        projeto: null,
        dataInicio: '',
        dataFim: '',
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelImpostosPorProjeto")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.impostos(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = {};
        this.setarProjeto();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.impostosExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      },
    },
    computed: {
      totalBruto() {
        return this.relatorio.reduce((total, item) => {
          return total + item.valorBruto;
        }, 0);
      },
      totalIrrf() {
        return this.relatorio.reduce((total, item) => {
          return total + item.irrf;
        }, 0);
      },
      totalInssRetencao() {
        return this.relatorio.reduce((total, item) => {
          return total + item.inssRetencao;
        }, 0);
      },
      totalIss() {
        return this.relatorio.reduce((total, item) => {
          return total + item.iss;
        }, 0);
      },
      totalCofins() {
        return this.relatorio.reduce((total, item) => {
          return total + item.cofins;
        }, 0);
      },
      totalCsll() {
        return this.relatorio.reduce((total, item) => {
          return total + item.csll;
        }, 0);
      },
      totalPis() {
        return this.relatorio.reduce((total, item) => {
          return total + item.pis;
        }, 0);
      },
      totalValorLiquido() {
        return this.relatorio.reduce((total, item) => {
          return total + item.valorLiquido;
        }, 0);
      },
      totalInssPatronal() {
        return this.relatorio.reduce((total, item) => {
          return total + item.inssPatronal;
        }, 0);
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Impostos`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">
      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Impostos" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th class="text-right">Período</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Data Emissão</th>
                    <th>Data</th>
                    <th>Histórico</th>
                    <th class="text-right">Bruto</th>
                    <th class="text-right">IRRF</th>
                    <th class="text-right">INSS Ret.</th>
                    <th class="text-right">ISS.</th>
                    <th class="text-right">COFINS.</th>
                    <th class="text-right">CSLL.</th>
                    <th class="text-right">PIS.</th>
                    <th class="text-right">Líquido</th>
                    <th class="text-right">INSS Pat.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in relatorio">
                    <td>{{ item.dataEmissao | formatarData }}</td>
                    <td>{{ item.data | formatarData }}</td>
                    <td>{{ item.historico }} - {{ item.nomeSubrubrica }} - {{ item.complemento }}</td>
                    <td class="text-right">{{ item.valorBruto | formatarNumero }}</td>
                    <td class="text-right">{{ item.irrf | formatarNumero }}</td>
                    <td class="text-right">{{ item.inssRetencao | formatarNumero }}</td>
                    <td class="text-right">{{ item.iss | formatarNumero }}</td>
                    <td class="text-right">{{ item.cofins | formatarNumero }}</td>
                    <td class="text-right">{{ item.csll | formatarNumero }}</td>
                    <td class="text-right">{{ item.pis | formatarNumero }}</td>
                    <td class="text-right">{{ item.valorLiquido | formatarNumero }}</td>
                    <td class="text-right">{{ item.inssPatronal | formatarNumero }}</td>
                  </tr>
                <tr>
                  <td class="text-right" colspan="3"><b>Total</b></td>
                  <td class="text-right text-danger">{{ totalBruto | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalIrrf | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalInssRetencao | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalIss | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalCofins | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalCsll | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalPis | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalValorLiquido | formatarNumero }}</td>
                  <td class="text-right text-danger">{{ totalInssPatronal | formatarNumero }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Impostos.vue